<template>

  <modal-layout
    :bgShow="errors"
    :modalShow="errors"
    @close="close">

    <div
      class="warning-modal">
      <div
        class="warning-modal__head">
        <img
          src="@/../static/img/icons/warning.svg">
        Ошибка
      </div>
      <div
        class="warning-modal__body">
        <div>
          Устройство с таким серийным номером не было найдено, проверьте корректность введенных данных.
        </div>
      </div>
      <div
        class="warning-modal__footer">
        <button
          class="btn cancel"
          @click.prevent="close()">
          Продолжить
        </button>
      </div>
    </div>

  </modal-layout>

</template>

<script>
import { mapState, mapMutations } from 'vuex';

import ModalLayout from './ModalLayout';

export default {
  components: {
    ModalLayout,
  },
  computed: {
    ...mapState('buymodels', ['errors']),
  },
  methods: {
    ...mapMutations('buymodels', ['SET_ERROR']),

    close() {
      this.SET_ERROR();
    },
  },
}
</script>

<style lang="sass">
  @import '@/styles/components/modals/warning-modal.sass'
</style>
